
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/atlas',
              siteOrigin: 'https://docs.mapbox.com',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/atlas/',
            getPage: () => import(
              /* webpackChunkName: "atlas" */
              '/work/atlas-docs/_batfish_tmp/_atlas.js'
            ),
            
            
          },{
            path: '/atlas/guides/',
            getPage: () => import(
              /* webpackChunkName: "atlas-guides" */
              '/work/atlas-docs/_batfish_tmp/_atlas_guides.js'
            ),
            
            
          },{
            path: '/atlas/guides/docker-compose/',
            getPage: () => import(
              /* webpackChunkName: "atlas-guides-docker-compose" */
              '/work/atlas-docs/_batfish_tmp/_atlas_guides_docker-compose.js'
            ),
            
            
          },{
            path: '/atlas/guides/kubernetes/',
            getPage: () => import(
              /* webpackChunkName: "atlas-guides-kubernetes" */
              '/work/atlas-docs/_batfish_tmp/_atlas_guides_kubernetes.js'
            ),
            
            
          },{
            path: '/atlas/guides/legacy/',
            getPage: () => import(
              /* webpackChunkName: "atlas-guides-legacy" */
              '/work/atlas-docs/_batfish_tmp/_atlas_guides_legacy.js'
            ),
            
            
          },{
            path: '/atlas/guides/products/',
            getPage: () => import(
              /* webpackChunkName: "atlas-guides-products" */
              '/work/atlas-docs/_batfish_tmp/_atlas_guides_products.js'
            ),
            
            
          },{
            path: '/atlas/guides/studio/',
            getPage: () => import(
              /* webpackChunkName: "atlas-guides-studio" */
              '/work/atlas-docs/_batfish_tmp/_atlas_guides_studio.js'
            ),
            
            
          },{
            path: '/atlas/guides/third-party-products/',
            getPage: () => import(
              /* webpackChunkName: "atlas-guides-third-party-products" */
              '/work/atlas-docs/_batfish_tmp/_atlas_guides_third-party-products.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };